<template>
  <v-container>
    <v-row justify="center" v-if="promocionSeleccionada != null">
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="items"
          item-key="id"
          :loading="loading"
          class="elevation-1"
          :options.sync="pagination"
          :server-items-length="totalDates"
          :footer-props="{
            'items-per-page-text': 'Citas por pagina',
            pageText: '{0}-{1} de {2}',
            'items-per-page-options': [25, 50, 100]
          }"
          :item-class="getRowProps"
          @click:row="handleRowClick"
        >
          <template v-slot:item.title="{ item }">
            <td style="width: 600px;">{{ item.title }}</td>
          </template>
          <template v-slot:no-data>
            <span>No se ha encontrado ningún elemento</span>
          </template>
          <template v-slot:no-results>
            <span>No se ha encontrado ningún elemento</span>
          </template>
          <template v-slot:item.sheets_cleaned="{ item }">
            {{ item.sheets_cleaned == 1 ? 'Cambiadas' : 'No cambiadas' }}
          </template>
          <template v-slot:item.towels_cleaned="{ item }">
            {{ item.towels_cleaned == 1 ? 'Cambiadas' : 'No cambiadas' }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-dialog v-model="dialogOpen" max-width="500px">
      <v-card>
        <v-card-title class="justify-center">Motivo del problema</v-card-title>
        <v-card-text>
          <p>{{ reasonProblem }}</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogOpen = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'LimpiezaAgenda',
  props: ['promocionSeleccionada', 'inicializado'],
  data() {
    return {
      loading: false,
      items: [],
      dialogOpen: false,
      reasonProblem: null,
      pagination: {
        page: 1,
        itemsPerPage: 50,
        sortBy: ['date'],
        sortDesc: [true],
        multiSort: false
      },
      totalDates: null
    }
  },
  computed: {
    ...mapGetters({
      user: 'login/user'
    }),
    headers() {
      return [
        {
          text: 'Fecha',
          align: 'start',
          sortable: true,
          value: 'fecha'
        },
        {
          text: 'Hora',
          align: 'start',
          sortable: true,
          value: 'time'
        },
        {
          text: 'Limpiadora',
          align: 'center',
          sortable: true,
          value: 'cleaner.name'
        },
        {
          text: 'Inmueble',
          align: 'start',
          sortable: true,
          value: 'building_desc'
        },
        {
          text: 'Inquilino',
          align: 'center',
          sortable: true,
          value: 'user.mixName'
        },
        {
          text: 'Estado',
          align: 'center',
          sortable: false,
          value: 'translatedState'
        },
        {
          text: 'Sabanas cambiadas',
          align: 'center',
          sortable: false,
          value: 'sheets_cleaned'
        },
        {
          text: 'Toallas cambiadas',
          align: 'center',
          sortable: false,
          value: 'towels_cleaned'
        }
      ]
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      getSchedule: 'cleaning/getSchedule'
    }),
    handleRowClick(item) {
      if (item.state === 90) {
        this.reasonProblem = item.problem_reason
        this.dialogOpen = true
      }
    },
    getRowProps(data) {
      let color = this.getCardColor(data.state)
      let pointer = ''
      if (data.state === 90) {
        pointer = 'cursor-pointer'
      }
      return [color, pointer]
    },
    getCardColor(state) {
      console.log(state)
      switch (state) {
        case 15:
          return 'amber lighten-4' // Amarillo pastel
        case 90:
          return 'red lighten-4' // Rojo pastel
        case 20:
          return 'green lighten-4' // Verde pastel
        default:
          return 'grey lighten-5' // Gris muy claro
      }
    },
    async loadSchedule() {
      this.loading = true
      const data = await this.getSchedule({
        promotion_code: this.promocionSeleccionada.promotion_code,
        filtros: {
          ...this.pagination
        }
      })
      this.items = data.items
      this.totalDates = data.totalItems
      this.loading = false
    }
  },
  watch: {
    pagination: {
      deep: true,
      async handler() {
        if (this.inicializado) {
          await this.loadSchedule()
        }
      }
    },
    promocionSeleccionada: {
      deep: true,
      async handler() {
        if (this.inicializado) {
          await this.loadSchedule()
        }
      }
    }
  }
}
</script>
<style>
.cursor-pointer {
  cursor: pointer;
}
</style>
